import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAtoxujluaDTKsK4-noJzyNXCSAAoRPQNA",
  authDomain: "wsj-demo-a1fd2.firebaseapp.com",
  projectId: "wsj-demo-a1fd2",
  storageBucket: "wsj-demo-a1fd2.firebasestorage.app",
  messagingSenderId: "497462303024",
  appId: "1:497462303024:web:b074205313ec7969cb10f5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export
export const auth = getAuth(app);
export const db = getFirestore(app);